import React from 'react'

const Footer = () => {
    return (
        <div>
            <div className="clearfix" />
            <footer className="loginfooter-lgn">
                <a href="javascript:void(0);" target="_blank" rel="noopener noreferrer">
                    <img src="/manage-iti.png" alt="Manage ITI" />
                </a>
                <img
                    style={{ float: "right", margin: "-26px 0 0 0" }}
                    src="/comodo_secure_113x59_transp.png"
                    width={113}
                    alt="Security Badge"
                />
            </footer>
        </div >
    )
}

export default Footer
